<template>
  <div class="tablearea_container">
    <Table
        :max-height="maxHeight"
        :loading="tableLoading"
        :columns="columns"
        :data="data"
        highlight-row
        no-data-text="无数据"
        sortable="custom"
        @on-selection-change="handleSelectionChange"
        @on-sort-change="handleSortChange"
    />
    <slot />
    <div
        v-if="data.length!=0"
        class="wrap_page"
    >
      <div class="font5_LightGray">
        共{{ total }}条记录
      </div>
      <Page
          :key="key"
          :total="total"
          show-sizer
          :current="curPage"
          :page-size="curPageSize"
          @on-change="onChange"
          @on-page-size-change="onPageSizeChange"
      />
    </div>
  </div>
</template>
<script>
/**
 *@TODO 组件可以考虑放入到iview.js中全局可引入 菜单联动还需改造 刷新也有问题
 *@overview table区域封装 表格、page页
 *@author [damon song]
 *@createDate [2020-06-26]
 *@param {Array} columns -表头
 *@param {Array} data -列表数据
 *@param {Number} total -总数据条数
 *@param {Number} pageNum -条数
 *@param {Number} pageSize -条数
 */
export default {
  return: {
    multipleSelection: ''
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    search: {
      type: Function
    },
    tableLoading: {
      type: Boolean
    },
    maxHeight: {
      type: Number,
      default: window.innerHeight - 340
    },
    total: Number,
    pageNum: Number,
    pageSize: Number
  },
  data () {
    return {
      curPage: this.pageNum,
      curPageSize: this.pageSize,
      key: 0
    }
  },
  watch: {
    pageNum (newValue, oldValue) {
      if (newValue) {
        this.curPage = newValue
      }
    },
    pageSize (newValue, oldValue) {
      if (newValue) {
        this.curPageSize = newValue
      }
    }
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection
    },
    onChange (index) {
      this.curPage = index
      this.key++
      // this.$refs['pages'].currentPage = 1;
      this.$emit("search", index, this.curPageSize)
    },
    onPageSizeChange (count) {
      this.curPageSize = count
      this.key++
      this.$emit("search", this.curPage, count)
    },
    handleSortChange ({ column, key, order }) {
      this.$emit('sort-change', key, order)
    }
  }
}
</script>
<style lang="less" scoped>
.tablearea_container {
  padding-top: 10px;
  .wrap_page {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px;
  }
}
</style>
<template>
  <div class="tablearea_container">
    <Table
        :max-height="maxHeight"
        :loading="tableLoading"
        :columns="columns"
        :data="data"
        highlight-row
        no-data-text="无数据"
        sortable="custom"
        @on-selection-change="handleSelectionChange"
        @on-sort-change="handleSortChange"
    />
    <slot />
    <div
        v-if="data.length!=0"
        class="wrap_page"
    >
      <div class="font5_LightGray">
        共{{ total }}条记录
      </div>
      <Page
          :key="key"
          :total="total"
          show-sizer
          :current="curPage"
          :page-size="curPageSize"
          @on-change="onChange"
          @on-page-size-change="onPageSizeChange"
      />
    </div>
  </div>
</template>
<script>
/**
 *@TODO 组件可以考虑放入到iview.js中全局可引入 菜单联动还需改造 刷新也有问题
 *@overview table区域封装 表格、page页
 *@author [damon song]
 *@createDate [2020-06-26]
 *@param {Array} columns -表头
 *@param {Array} data -列表数据
 *@param {Number} total -总数据条数
 *@param {Number} pageNum -条数
 *@param {Number} pageSize -条数
 */
export default {
  return: {
    multipleSelection: ''
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    search: {
      type: Function
    },
    tableLoading: {
      type: Boolean
    },
    maxHeight: {
      type: Number,
      default: window.innerHeight - 340
    },
    total: Number,
    pageNum: Number,
    pageSize: Number
  },
  data () {
    return {
      curPage: this.pageNum,
      curPageSize: this.pageSize,
      key: 0
    }
  },
  watch: {
    pageNum (newValue, oldValue) {
      if (newValue) {
        this.curPage = newValue
      }
    },
    pageSize (newValue, oldValue) {
      if (newValue) {
        this.curPageSize = newValue
      }
    }
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection
    },
    onChange (index) {
      this.curPage = index
      this.key++
      // this.$refs['pages'].currentPage = 1;
      this.$emit("search", index, this.curPageSize)
    },
    onPageSizeChange (count) {
      this.curPageSize = count
      this.key++
      this.$emit("search", this.curPage, count)
    },
    handleSortChange ({ column, key, order }) {
      this.$emit('sort-change', key, order)
    }
  }
}
</script>
<style lang="less" scoped>
.tablearea_container {
  padding-top: 10px;
  .wrap_page {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px;
  }
}
</style>
